import React, { useState } from 'react';
import { challengeHasWorkoutPlan, getChallengeWorkoutPlan } from '../../utils/challengeWorkoutPlan';
import WorkoutPlanModal from './WorkoutPlanModal';

export default function ChallengeWorkoutPlanButton({ challenge, className = '' }) {
	const [open, setOpen] = useState(false);
	const plan = getChallengeWorkoutPlan(challenge);

	if (!challengeHasWorkoutPlan(challenge)) return null;

	return (
		<>
			<button
				type="button"
				onClick={() => setOpen(true)}
				className={`inline-flex items-center gap-1.5 rounded-lg border border-gray-300 dark:border-dark-border bg-white dark:bg-dark-bg px-2.5 py-1 text-xs font-medium text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-gray-800 transition ${className}`}
				aria-label={`View workout plan for ${challenge.title}`}
			>
				<i className="fa-solid fa-dumbbell text-blue-600 dark:text-blue-400" aria-hidden="true" />
				View plan
			</button>
			<WorkoutPlanModal isOpen={open} onClose={() => setOpen(false)} plan={plan} />
		</>
	);
}
